export default __webpack_public_path__ + "static/media/Armbands of Effulgent Devotion.b4b2266b.jpg";